import React from 'react';
import GenericModal from '../../../components/agv-generic-modal';
import { MODAL_SIZE, MODAL_SIZE_STYLE } from '../../../enums/modal-size.enum';

/**
 * Confirmation avant de relancer un envoi (ou, avec count, une sélection d'envois) vers l'AS400 Cooperl.
 */
export default function ConfirmRetryModal({
  isOpen,
  setIsOpen,
  log,
  count,
  onConfirm,
  isLoading,
}) {
  return (
    <GenericModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={
        count
          ? `Relancer ${count} envoi${count > 1 ? 's' : ''} ?`
          : 'Relancer l’envoi ?'
      }
      size={MODAL_SIZE_STYLE[MODAL_SIZE.MD]}
      secondaryActionText="Annuler"
      secondaryAction={() => setIsOpen(false)}
      mainActionText={count ? `Relancer (${count})` : 'Relancer'}
      mainAction={onConfirm}
      mainActionIsLoading={isLoading}
    >
      <div className="tw-flex tw-flex-col tw-gap-2 tw-text-sm">
        <p className="tw-m-0">
          {count ? (
            <>
              Les données des <strong>{count}</strong> tournée
              {count > 1 ? 's' : ''} sélectionnée{count > 1 ? 's' : ''} seront
              renvoyées à l’AS400 Cooperl dans les minutes qui suivent.
            </>
          ) : (
            <>
              Les données de la tournée <strong>{log?.tour_key}</strong> seront
              renvoyées à l’AS400 Cooperl dans la minute.
            </>
          )}
        </p>
        <p className="tw-m-0 tw-text-text-dark-medium-importance">
          Un seul essai est fait : en cas de nouvel échec, l’envoi repasse en
          « Action requise ». Si l’AS400 a refusé les données, corrigez-les
          d’abord.
        </p>
      </div>
    </GenericModal>
  );
}
